<!--suppress ALL -->
<script lang="ts">
import {statusVirtualAccounts} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class StatusVirtualAccountSelect extends Vue {

    @Prop({default: statusVirtualAccounts[0], type: String})
    public status: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectStatusVirtual(param: any) {
      this.$emit('update:status', param || statusVirtualAccounts[0]);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, status, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: status,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.status')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectStatusVirtual}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(statusVirtualAccounts).map((item: any) => {
        const option: any = {attrs: {value: item}};

        return createElement('option', option, item.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.status'), message, type}}, [main]);
    }
  }
</script>
